import logo from './logo.svg';
import './App.css';
import EmailForm from './EmailForm';
import LandingPage from './LandingPage';

function App() {
  return (
    <div className="App">
      <LandingPage />
      {/* <EmailForm /> */}

    </div>
  );
}

export default App;
